const styles = {
  content_link_wrapper: {
    margin: 'auto 0',
    ml: 1,
  },
  descriptionItem: {
    display: 'flex',
    alighItems: 'flex-start',
    whiteSpace: 'pre-wrap',
    marginBottom: {
      xs: '12px',
      md: '18px',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
};

export default styles;
